<template>
  <nav>
    <!-- Logo 和公司名称容器 -->
    <div class="nav-header">
      <div class="logo-container">
        <img src="@/assets/logo.png" alt="Logo" class="logo" />
        <span class="company-name">好端端教育</span>
      </div>
       <!-- 图片按钮 -->
        <button class="toggle-button" @click="toggleNav">
          <img
            :src="isNavOpen ? menuOpen : menuClose"
            alt="Toggle Menu"
            class="toggle-icon"
          />
        </button>
    </div>

    <!-- 导航链接 -->
    <div class="nav-links" :class="{ open: isNavOpen }">
      <div  v-for="link in navLinks" :key="link.to">
          <router-link :to="link.to">{{ link.text }}</router-link>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import menuOpen from '@/assets/menu-open.png';
import menuClose from '@/assets/menu-close.png';
import { NavLink } from "@/types/system/NavLink"
// 控制导航栏的展开和关闭
const isNavOpen = ref<boolean>(false);

// 切换导航栏状态
const toggleNav = () => {
  isNavOpen.value = !isNavOpen.value;
};

const navLinks: NavLink[] = [
  { to: '/', text: '首页' },
  { to: '/course', text: '课程' },
  { to: '/testhome', text: '测试' },
  { to: '/personal-center', text: '个人中心' },
  // {to:'/admin-home',text:'后台管理'}
];


</script>

<style scoped>
/* 基础样式 */
nav {
  /* padding: 20px; */
  background-color: #ffffff;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-header {
  display: flex;
  align-items: center;
}

.logo-container {
  display: flex;
  align-items: center;
  gap: 10px;
  /* Logo 和公司名称之间的间距 */
}

.logo {
  height: 40px;
  width: auto;
}

.company-name {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.toggle-button {
  background: none;
  border: none;
  cursor: pointer;
  display: none;
  /* 默认隐藏按钮 */
}

.toggle-icon {
  width: 24px;
  /* 图片宽度 */
  height: 24px;
  /* 图片高度 */
}

.nav-links {
  display: flex;
  gap: 20px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
}

nav a.router-link-exact-active {
  color: #42b983;
}

/* 响应式布局 */
@media (max-width: 768px) {

  /* 手机端 */
  nav {
    flex-direction: column;
    padding: 10px;
  }

  .nav-header {
    width: 100%;
    justify-content: space-between;
  }

  .toggle-button {
    display: block;
    /* 显示按钮 */
  }

  .nav-links {
    display: none;
    /* 默认隐藏链接 */
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
    width: 100%;
    align-items: center; /* 居中 */
    text-align: left; /* 文字左对齐 */
  }

  .nav-links.open {
    display: flex;
    flex-direction: column;
 
    /* 展开时显示链接 */
  }
}

@media (min-width: 769px) and (max-width: 1024px) {

  /* 平板端样式 */
  nav {
    padding: 15px;
  }

  .nav-links {
    gap: 15px;
  }
}

@media (min-width: 1025px) {

  /* PC 端样式 */
  nav {
    padding: 20px;
  }

  .nav-links {
    gap: 20px;
  }
}</style>